module.exports = __webpack_public_path__ + "static/logo_en-125643d8232cf77685355ec152576259.png";